import { type FC, memo } from 'react';
import cn from 'classnames';

import { type GameItemRewardProps } from '@/common/types/components';

import { GameItemReward } from './GameItemReward';

interface GameItemsRewardsProps {
  className?: string;
  list: GameItemRewardProps[];
}

const GameItemsRewards: FC<GameItemsRewardsProps> = memo(
  ({ list, className }) => {
    return (
      <div
        className={cn(
          'flex items-center shrink-0 gap-2 mt-[min(2.6svh,_24px)] mb-[0.125rem] min-h-[3.875rem] sm-h:mt-0 sm-h:mb-0 h-[3.875rem] min-w-1',
          className,
        )}
      >
        {list.map((props, index) => (
          <GameItemReward key={index} {...props} />
        ))}
      </div>
    );
  },
);

export { GameItemsRewards };
